import { useBudouX } from "@/hooks/useBudouX";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import SpeedCmsPointsTable from "./SpeedCmsPointsTable";

const points = [
  {
    id: "1",
    title: "どんなエンタープライズ対応の管理基盤サーバーでも軽快動作",
    desc: '複数管理者・アクセス制御・決裁（承認）フローなど、エンタープライズユース基準の必要機能を標準搭載<br class="tbpc" />決裁（承認）フローは使いやすい操作感、コメント付きで、回付・差戻が簡単に行えます<br class="tbpc" />またSpeedCMSシステム設定により、回付ルート設定も、組織に合わせ自由に行えます',
  },
  {
    id: "2",
    title: "要件に沿った作り込み、自由自在なカスタマイズ",
    desc: "他CMSでは高コストで実現できなかったことも、SpeedCMSでは柔軟なカスタマイズ･要件に沿った作り込みが可能です",
    sub: [
      {
        title: "データテーブル",
        label:
          "任意のフォーマットでのデータテーブル定義。Speed関数によるデータ呼び出しが可能です",
      },
      {
        title: "Speed関数",
        label:
          "Excel関数感覚で使える便利な関数群を用意。追加要件に対応する開発工数も、大幅に圧縮できます",
      },
      {
        title: "Speedテンプレート",
        label:
          "業務特化型の拡張テンプレートも多数用意しています（業務特化型拡張テンプレート）",
      },
    ],
  },
  {
    id: "3",
    title: "低スペック環境でも軽快動作",
    desc: "Webインフラ環境への投資に対するコストパフォーマンスが飛躍的に向上します",
    table: true,
  },
];

export const SpeedCmsPoints = (props) => {
  const { parse } = useBudouX();
  return (
    <>
      <h3 className="w-full font-bold text-sec fluid-text-[11px,18px]">
        Points of SpeedCMS
      </h3>
      <div className="flex w-full flex-col items-start justify-start gap-5 fluid-text-[14px,18px]">
        {points.map((point) => (
          <dl key={point.id} className="w-full space-y-2">
            <dt className="flex flex-row items-center gap-2 font-bold text-pri fluid-text-[16px,22px]">
              <FontAwesomeIcon icon={faCheck} className="text-ylw" />
              <div
                dangerouslySetInnerHTML={{
                  __html: `${point.title}`,
                }}
              />
            </dt>
            <dd className="leading-comfort text-txt-base md:pl-7">
              <div
                dangerouslySetInnerHTML={{
                  __html: `${point.desc}`,
                }}
              />
              {point.sub && (
                <div className="mt-2 flex flex-col gap-2  md:gap-1">
                  {point.sub.map(function (point) {
                    return (
                      <div key={point.id} className="">
                        <h3 className="inline font-bold text-sec">
                          {point.title}
                        </h3>
                        <span>&nbsp;──&nbsp;</span>
                        <div
                          className="inline leading-snug fluid-text-[16px,18px]"
                          dangerouslySetInnerHTML={{
                            __html: `${point.label}`,
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
              {point.table && <SpeedCmsPointsTable />}
            </dd>
          </dl>
        ))}
      </div>
    </>
  );
};
